<template>
  <div class="basics-style">
    <slot />
  </div>
</template>
<style lang="postcss">
@import '@/css/resume/markdown-basic.css';
</style>
